module.exports = __webpack_public_path__ + "media/images/admin/favicons/apple-touch-icon-01775222a2e7ae467130501335cf0e5a.png";